import { resumeSubscriptionApi as generatedResumeSubscriptionApi } from '../generated/billing/resumeSubscription';

import { getMySubscriptionStatusApi } from './getMySubscriptionStatus';

const resumeSubscriptionApi = generatedResumeSubscriptionApi.enhanceEndpoints({
  endpoints: {
    resumeSubscription: {
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          getMySubscriptionStatusApi.util.updateQueryData('getMySubscriptionStatus', undefined, (draft) => {
            draft.status = data.stripeStatus;
            draft.period.cancelAt = data.cancelAt ?? null;
          }),
        );
      },
    },
  },
});

export const { useResumeSubscriptionMutation } = resumeSubscriptionApi;
